import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      color: "#696969",
      paddingLeft: 32,
      paddingRight: 32,
    },
  });

  export const useStyles = makeStyles(styles);